// extracted by mini-css-extract-plugin
export default {"siteWrapper":"App_siteWrapper__SBJkz","notFoundPageWrapper":"App_notFoundPageWrapper__F4NmL","logo":"App_logo__KFImf"};